import { jsx as _jsx } from "react/jsx-runtime";
import { useRfiResponseWorkspace } from '../../pages/RfiResponse/hooks';
import { useRfiQuestions } from '../../pages/RfiResponse/rfiQuestionHooks';
import { rfiNavCountsToKeys, useRfiNavCounts } from '../../pages/RfiResponse/workspace/useRfiAnswerSections';
import { RecordSidebar } from './RecordSidebar';
import { formatRfiDue, RFI_NAV_GROUPS } from './rfiNav';
/** RFI response record rail (FND-19, §4.2). Back goes to the first linked pursuit, else Growth. */ export function RfiSidebar({ rfiResponseId }) {
    const { data } = useRfiResponseWorkspace(rfiResponseId);
    const summary = data?.summary;
    const pursuit = data?.linkedPursuits?.[0];
    const pangaeaId = summary?.rfiResponseProjectId ?? '';
    // WRT-05: counts from GetRfiNavCounts; until it answers, the question count is every listed question.
    const navCounts = useRfiNavCounts(pangaeaId);
    const questions = useRfiQuestions(navCounts.data ? '' : pangaeaId);
    const due = summary?.responseDue?.toDate();
    return /*#__PURE__*/ _jsx(RecordSidebar, {
        back: pursuit ? {
            label: pursuit.captureName,
            href: `/capture/${pursuit.captureProjectId}`
        } : {
            label: 'Growth',
            href: '/growth'
        },
        basePath: `/rfi-response/${rfiResponseId}`,
        counts: navCounts.data ? rfiNavCountsToKeys(navCounts.data) : {
            questions: questions.data?.questions.length
        },
        groups: RFI_NAV_GROUPS,
        name: summary?.title || 'RFI response',
        navigationLabel: "RFI response navigation",
        subtitle: due ? `RFI response · due ${formatRfiDue(due)}` : 'RFI response'
    });
}
